import React from 'react';
import './NavigationItem.less';
import {IconBadge} from 'elements/icon-badge/IconBadge';
import {NavigationLink} from 'elements/navigation-link/NavigationLink';
import {IconBadgeColors} from "../../elements/icon-badge/IconBadge";


export const NavigationItem = ({icon, name, iconColor, isPrimary}) => {
	return (
		<div className={`navigation-item ${
			isPrimary ? 'navigation-item--primary' : ''
		}`}>
      <span className="navigation-item__icon">
        <IconBadge icon={icon} color={isPrimary ? IconBadgeColors.primary : iconColor}/>
      </span>
			<span className="navigation-item__name">
        <NavigationLink text={name} isPrimary={isPrimary}/>
      </span>
		</div>
	);
};
